<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              物料名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectMaterialFun()"
            >
              选择物料
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          :multiple-selection.sync="multipleSelection"
          @reloadData="loadTableData(tableList)"
          @selectMaterial="selectMaterialFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadStoreVisitMaterialsDetailListDataApi } from '@/api/storeVisitReport'
export default {
  name: 'VisitMaterialLeftList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    selectedMaterials: {
      type: Array,
      default: null
    },
    storeId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'visit_material_left_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该物料',
            method: 'selectMaterial'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: 'bill.id', // 排序字段
            order: 'desc' // 排序类型 ascending升序 descending降序
          },
          search: {
            materialsName: '',
            storeId: '',
            isHasLeft: 1,
            usedMethodId: 5
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          // { prop: 'storeName', label: '零售户', filterColumn: 's.store_name', width: 100 },
          // { prop: 'certificateNo', label: '专卖证号', filterColumn: 's.certificate_no', width: 120 },
          // { prop: 'visitDateStr', label: '拜访日期', filterColumn: 'tsvr.visit_date', width: 110, isBetween: true },
          // { prop: 'manageUserName', label: '维护人', filterColumn: 's.manage_user_name', width: 100 },
          { prop: 'schemeName', label: '方案名称', filterColumn: 'bill.scheme_name', width: 200 },
          { prop: 'schemeNo', label: '方案编号', filterColumn: 'bill.scheme_no', width: 150 },
          { prop: 'materialsName', label: '物料名称', filterColumn: 'bill.materials_name' },
          // { prop: 'sourceTypeStr', label: '物料来源', filterColumn: '(case bill.source_type when 1 then "自制" when 2 then "中心配送" else "" end)', width: 120 },
          { prop: 'unitName', label: '物料单位', filterColumn: 'bill.unit_name', width: 110 },
          { prop: 'amount', label: '发放数量', filterColumn: 'bill.amount', width: 120, isBetween: true },
          { prop: 'leftAmount', label: '未使用数量', filterColumn: 'bill.left_amount', width: 120, isBetween: true },
          { prop: 'usedMethod', label: '用途', filterColumn: 'bill.used_method', width: 100 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.search.storeId = this.storeId
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      this.tableList.tableQuery.sort.order = 'desc'
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadStoreVisitMaterialsDetailListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择物料
    selectMaterialFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择物料',
          type: 'warning'
        })
        return
      } else {
        this.$emit('selectedMaterialsFun', this.multipleSelection)
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
